import { Form, Formik } from 'formik';
import { Props, Values } from './ForgotPasswordForm.types';
import * as Yup from 'yup';
import Button from '../../components/button/Button';
import FormField from '../../components/field/FormField';

export const ForgotPasswordForm = ({ onSubmit, initialValues }: Props) => {
  const _initialValues: Values = {
    email: '',
  };

  const SignInSchema = Yup.object().shape({
    email: Yup.string().email('E-mail is invalid').required('E-mail is required.'),
  });

  return (
    <Formik
      initialValues={initialValues || _initialValues}
      onSubmit={onSubmit}
      validationSchema={SignInSchema}
    >
      {({ errors, touched }) => (
        <Form>
          <div className="my-4">
            <FormField
              id="email"
              name="email"
              label="E-mail"
              errors={errors}
              touched={touched}
            />
          </div>
          <Button type="submit" title="Send request" fullWidth />
        </Form>
      )}
    </Formik>
  );
};
